import { UAParser } from 'ua-parser-js';

export type DeviceMetadata = {
  deviceType: string;
  deviceModel: string;
  deviceVendor: string;
  engineName: string;
  engineVersion: string;
  osName: string;
  osVersion: string;
  browserName: string;
  browserVersion: string;
  arch: string;
};
export function getDeviceMetadata(userAgent: string) {
  const { browser, cpu, device, os, engine } = UAParser(userAgent);
  const deviceType = device.type || 'unknown';
  const deviceModel = device.model || 'unknown';
  const deviceVendor = device.vendor || 'unknown';

  const engineName = engine.name || 'unknown';
  const engineVersion = engine.version || 'unknown';
  const osName = os.name || 'unknown';
  const osVersion = os.version || 'unknown';
  const browserName = browser.name || 'unknown';
  const browserVersion = browser.version || 'unknown';
  const arch = cpu.architecture || 'unknown';

  const deviceMetadata: DeviceMetadata = {
    deviceType,
    deviceModel,
    deviceVendor,
    engineName,
    engineVersion,
    osName,
    osVersion,
    browserName,
    browserVersion,
    arch,
  };
  return deviceMetadata;
}

/**
 * Called client-side.
 * navigator needs to be presented.
 *
 * @type {navigator.userAgent}
 *
 * @returns {DeviceMetadata}
 */
export function getUserDeviceFromNavigator(): DeviceMetadata {
  return getDeviceMetadata(navigator.userAgent);
}
